<script>
import { EventBus } from "../lib/event-bus.js"
import AccordianItem from "./AccordianItem.vue";

export default {
  props: {
    open: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      openItems: this.open
    }
  },

  components: {
    AccordianItem
  },

  created() {
    EventBus.$on('open-accordian-item', (itemRef) => {
      this.openItems.push(itemRef)
    });

    EventBus.$on('close-accordian-item', (itemRef) => {
      //  remove item from array
      const index = this.openItems.indexOf(itemRef)
      if (index > -1) {
        this.openItems.splice(index, 1);
      }
    });
  },

  watch: {
    openItems(newVal) {
      // URLSearchParams is already polyfilled for Craft Ajax in main.js
      const params = new URLSearchParams();
      params.set('open', newVal.filter(String)); // filter out non string values
      console.log(`${window.location.pathname}?${params}`);
      history.replaceState({}, document.title, `${window.location.pathname}?${params}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/Accordian.vue